import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CountryProvider } from "./context/CountryContext";
import { LanguageProvider } from "./i18n/LanguageContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Documents from "./pages/Documents";
import Analyses from "./pages/Analyses";
import SOS from "./pages/SOS";
import Pro from "./pages/Pro";
import AuthCallback from "./pages/AuthCallback";
import MedicalUrgence from "./pages/MedicalUrgence";
import Refuge from "./pages/Refuge";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import MediaKit from "./pages/MediaKit";
import ProtectedRoute from "./components/ProtectedRoute";
import CountryRoute from "./components/CountryRoute";
import ReferralTracker from "./components/ReferralTracker";
import InstallPWA from "./components/InstallPWA";
import AIHelper from "./components/AIHelper";
import UrgentNotifications from "./components/UrgentNotifications";

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/be" element={<CountryRoute />} />
      <Route path="/fr" element={<CountryRoute />} />
      <Route path="/lu" element={<CountryRoute />} />
      <Route path="/ch" element={<CountryRoute />} />
      <Route path="/pro" element={<Pro />} />
      <Route path="/urgence/:token" element={<MedicalUrgence />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/media-kit" element={<MediaKit />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/documents"
        element={
          <ProtectedRoute>
            <Documents />
          </ProtectedRoute>
        }
      />
      <Route
        path="/analyses"
        element={
          <ProtectedRoute>
            <Analyses />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sos"
        element={
          <ProtectedRoute>
            <SOS />
          </ProtectedRoute>
        }
      />
      <Route
        path="/refuge"
        element={
          <ProtectedRoute>
            <Refuge />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <CountryProvider>
              <ReferralTracker />
              <AppRouter />
              <Toaster position="top-right" richColors />
              <AIHelper />
              <InstallPWA />
              <UrgentNotifications />
            </CountryProvider>
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
